import type { UseCase } from '@/core/shared'
import type { StripeRepository } from '@/core/stripe'

export const getLinkPaymentsAccount: UseCase<StripeRepository, 'getLinkPaymentsAccount'> = repository => {
  return async (payload) => {
    return await repository.getLinkPaymentsAccount(payload)
  }
}
